import { IAddressInfoSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';
import { IAddressInfo } from 'shared/types/geo/address';

export const defaultTitleFromAddress = (address: IAddressInfoSchema[] & IAddressInfo[]) => {
  const addressWithoutStreet = address.filter(
    addr => addr.type === 'raion' || addr.type === 'okrug' || addr.type === 'location',
  );

  return addressWithoutStreet.map(a => a.shortName).join(', ');
};
